export const CTopFooterLinks = {
  field: `
      fragment topFooterLinks on topFooterLinks_MatrixField {
        ... on topFooterLinks_links_BlockType {
          id
          linkName
          linkUrl
          linkPosition
        }
      }
    `,
}
